export { useTheme as default } from 'next-themes';
